import React from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Color from "color"

import StyleSheet, { colorPalette } from 'styles'
import {FormattedMessage} from 'react-intl'

const styles = StyleSheet({
  button: {
    flexGrow: 1,

    fontSize: '10px',
    fontWeight: 'bold',
    textTransform: 'none',
    color: '#a4a4a4',

    borderRadius: 0,
    margin: 0,
    borderWidth: '1px 0px 1px 1px',
    borderStyle: 'solid',
    borderColor: '#c7c7c7',

    minHeight: '22px',
    paddingBottom: '3px',
    paddingTop: '5px',

    '&:first-child': {
      borderTopLeftRadius: '4px',
      borderBottomLeftRadius: '4px'
    },
    '&:last-child': {
      borderTopRightRadius: '4px',
      borderBottomRightRadius: '4px',
      borderRightWidth: '1px'
    },
    '&:hover': {
      backgroundColor: Color('#fff').darken(0.1).hex()
    }
  },
  primary: {
    backgroundColor: colorPalette.secondary[0].hex(), //'#095084'
    borderColor: colorPalette.secondary[0].hex(), //'#095084',
    color: '#ffffff',
    '&:hover': {
      backgroundColor: colorPalette.secondary[0].lighten(0.1).hex()
    }
  },
  dark: {
    '&$button': {
      '&:hover': {
        backgroundColor: 'rgba(255,255,255,0.2)'
      },
      '&$primary': {
        backgroundColor: '#fff',
        color: '#1B3044',
        borderColor: '#c7c7c7',
      }
    },
  }
}, {classNamePrefix: 'Segment-'})

function Segment(props) {
  const { active, label, value, onSelected, dark } = props
  const className = styles({button: true, primary: !!active, dark: !!dark})

  return (
    <Button key={label} color={(!!active) ? 'primary' : 'secondary'} variant='flat' className={className}
      onClick={() => onSelected({label, value})}><FormattedMessage id={label} /></Button>
  )
}

Segment.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.object.isRequired,
  active: PropTypes.bool,
  onSelected: PropTypes.func,
}

export default Segment